<template>
    <LayoutSub className="table_order">
        <SubSection className="pb-0">
            <StickyContainer title="EasyOrder+"
                subText="점심에는 선결제 패드로, 저녁에는 메뉴판으로 필요에 따라 바꿔가며<br>사용할 수 있어 효율적인 홀 운영이 가능하며 메인 포스와<br>테이블 오더가 쌍방향으로 통신하여 주문 누락을 방지할 수 있습니다."
                :leftItems="orderLeftItems" :rightItems="orderRightItems">
            </StickyContainer>
        </SubSection>
    </LayoutSub>
</template>
<script>
import LayoutSub from '@/layouts/LayoutSub.vue';
import SubSection from '@/components/SubSection.vue';
import StickyContainer from '@/components/StickyContainer.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
        StickyContainer
    },
    data() {
        return {
            orderLeftItems: [
                { text: "심미성 있는 배경 테마", active: true },
                { text: "커스텀 로고 사용 기능", active: false },
                { text: "주문 확인", active: false },
                { text: "직원 호출, 물 등 0원 물품 추가 기능", active: false },
                { text: "장바구니 기능", active: false },
                { text: "각종 부가 팝업창", active: false },
                { text: "화면 Swipe", active: false },
                { text: "다국어 기능", active: false }
            ],
            orderRightItems: [
                {
                    img: require("@/assets/table_img_1.png"),
                    title: "심미성 있는 배경 테마",
                    description: "레드, 블루, 오렌지, 옐로우, 핑크 등 사용자가 원하는 색상 커스텀 가능",
                    colors: [
                        { className: "light_red" },
                        { className: "red" },
                        { className: "light_blue" },
                        { className: "orange" },
                        { className: "yellow" },
                        { className: "pink" },
                    ],
                    customColor: "+ Custom",
                },
                {
                    img: require("@/assets/table_img_2.png"),
                    title: "커스텀 로고 사용 기능",
                    description:
                        "브랜드 고유 로고를 삽입하여 가맹점 맞춤 커스터마이징 가능",
                },
                {
                    img: require("@/assets/table_img_3.png"),
                    title: "주문 확인",
                    description:
                        "개별 주문 이후 주문확인창 팝업으로 주문 실수 및 누락에 대한 더블 체크 가능",
                },
                {
                    img: require("@/assets/table_img_4.png"),
                    title: "직원 호출, 물 등 0원 물품 추가 기능",
                    description:
                        "직원호출 및 요구사항을 한 번에 전달하여 홀 운영 효율성 제고",
                },
                {
                    img: require("@/assets/table_img_5.png"),
                    title: "장바구니 기능",
                    description:
                        "장바구니 담기를 통해 주문 실수 최소화 / 수량 조절, 취소 등이 쉬운 User-Friendly한 UI",
                },
                {
                    img: require("@/assets/table_img_6.png"),
                    title: "각종 부가 팝업창",
                    description:
                        "오더관리, 상품설명 등 팝업창을 통해 소비자의 '알 권리' 제공",
                },
                {
                    img: require("@/assets/table_img_7.png"),
                    title: "화면 Swipe",
                    description:
                        "터치기 배열에 대한 스와이프 기능 적용으로 순쉬운 메뉴 찾기 가능",
                },
                {
                    img: require("@/assets/table_img_8.png"),
                    title: "다국어 기능",
                    description:
                        "한국어, 영어, 일본어, 중국어 지원",
                    subimg: require("@/assets/table_img_11.png"),
                },
                {
                    multiimg: require("@/assets/table_img_9.png"),
                    multiimgs: require("@/assets/table_img_10.png")
                }
            ]
        }
    }
}
</script>